import { useEffect, useState } from 'react';

type Breakpoint = 'mobile' | 'tablet' | 'mediumMobile' | 'laptop';
// TODO: Need to refactor to return automatically screen type instead of boolean
const BREAKPOINTS: Record<Breakpoint, number> = {
  mediumMobile: 375,
  mobile: 480,
  tablet: 768,
  laptop: 1024,
};

const useBreakpoint = (breakpoint: Breakpoint): boolean => {
  const [isMatch, setIsMatch] = useState<boolean>(() => {
    if (typeof window === 'undefined') {
      return false;
    }

    return window.innerWidth <= BREAKPOINTS[breakpoint];
  });

  useEffect(() => {
    const query = `(max-width: ${BREAKPOINTS[breakpoint]}px)`;
    const mediaQueryList = window.matchMedia(query);

    const listener = (event: MediaQueryListEvent) => {
      setIsMatch(event.matches);
    };

    mediaQueryList.addEventListener('change', listener);

    return () => {
      mediaQueryList.removeEventListener('change', listener);
    };
  }, [breakpoint]);

  return isMatch;
};

export default useBreakpoint;
